import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { ChatbotConversationsPageSize } from '../../../types/userConfig';
import {
  buildConversationsListOptions,
  buildConversationsSearchParams,
  parseConversationsPageFromSearchParams,
} from '../chatbotConversationsListParams';

export function useChatbotConversationsListSearchParams(
  pageSize: ChatbotConversationsPageSize,
) {
  const [searchParams, setSearchParams] = useSearchParams();

  const page = useMemo(
    () => parseConversationsPageFromSearchParams(searchParams),
    [searchParams],
  );

  const setPage = useCallback(
    (nextPage: number) => {
      setSearchParams(buildConversationsSearchParams(nextPage), {
        replace: true,
      });
    },
    [setSearchParams],
  );

  const listOptions = useMemo(
    () => buildConversationsListOptions(page, pageSize),
    [page, pageSize],
  );

  return {
    page,
    setPage,
    listOptions,
  };
}
